<template>
    <div class="floating-window"
         :style="{ top: position.y + 'px', left: position.x + 'px', width: size.width + 'px', height: size.height + 'px' }"
         @mousedown="startDragging">
        <div class="window-header">{{ title ?? '' }}
            <QBtn size="sm" flat round dense color="primary"
               icon="mdi-close-box-outline"
               @click="$emit('close')"
               >
            </QBtn>
        </div>
        <div class="window-content">
            <div class="keypad-container">
                <div class="keypad">
                    <div class="keypad-grid">
                        <QBtn v-for="key in keys"
                               :key="key.number"
                               class="keypad-button"
                               flat
                               no-caps
                               @click="pressKey(key)">
                            <QIcon :name="key.icon" size="md" color="primary" />
                            <span v-show="false">{{ key.number }}</span>
                            <span v-if="key.letters" style="font-size: 0.6rem; color: #666;">{{ key.letters }}</span>
                        </QBtn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { QBtn, QIcon } from 'quasar';
    import { common } from '../shared/helpers.js';

    export default {
        name: 'PhoneKeypad',
        components: { QBtn, QIcon },
        emits: ['close','keypress'],
        props: {
            title: null,
            initialX: { type: Number, default: 100 },
            initialY: { type: Number, default: 100 },
            initialWidth: { type: Number, default: 300 },
            initialHeight: { type: Number, default: 420 },
            minWidth: { type: Number, default: 100 },
            minHeight: { type: Number, default: 100 },
        },
        data() {
            return {
                position: { x: this.initialX, y: this.initialY },
                size: { width: this.initialWidth, height: this.initialHeight },
                isDragging: false,
                isResizing: false,
                resizeDirection: '',
                startPos: { x: 0, y: 0 },
                startSize: { width: 0, height: 0 },
                startMouse: { x: 0, y: 0 },

                keys: [
                    { number: '1', icon: 'mdi-numeric-1', letters: '' },
                    { number: '2', icon: 'mdi-numeric-2', letters: 'ABC' },
                    { number: '3', icon: 'mdi-numeric-3', letters: 'DEF' },
                    { number: '4', icon: 'mdi-numeric-4', letters: 'GHI' },
                    { number: '5', icon: 'mdi-numeric-5', letters: 'JKL' },
                    { number: '6', icon: 'mdi-numeric-6', letters: 'MNO' },
                    { number: '7', icon: 'mdi-numeric-7', letters: 'PQRS' },
                    { number: '8', icon: 'mdi-numeric-8', letters: 'TUV' },
                    { number: '9', icon: 'mdi-numeric-9', letters: 'WXYZ' },
                    { number: '*', icon: 'mdi-asterisk', letters: '' },
                    { number: '0', icon: 'mdi-numeric-0', letters: '+' },
                    { number: '#', icon: 'mdi-pound', letters: '' },
                ],
            };
        },
        created() {
            const settings = common.getGlobalSetting('keypad');
            if (settings) {
                this.position.x = settings.x;
                this.position.y = settings.y;
            }
        },
        methods: {
            startDragging(event) {
                if (event.target.classList.contains('window-header')) {
                    this.isDragging = true;
                    this.startMouse = { x: event.clientX, y: event.clientY };
                    this.startPos = { x: this.position.x, y: this.position.y };
                    document.addEventListener('mousemove', this.handleDragging);
                    document.addEventListener('mouseup', this.stopDragging);
                }
            },
            handleDragging(event) {
                if (this.isDragging) {
                    const dx = event.clientX - this.startMouse.x;
                    const dy = event.clientY - this.startMouse.y;
                    this.position.x = Math.max(0, this.startPos.x + dx);
                    this.position.y = Math.max(0, this.startPos.y + dy);
                }
            },
            stopDragging() {
                this.isDragging = false;
                document.removeEventListener('mousemove', this.handleDragging);
                document.removeEventListener('mouseup', this.stopDragging);
            },
            startResizing(direction, event) {
                this.isResizing = true;
                this.resizeDirection = direction;
                this.startSize = { width: this.size.width, height: this.size.height };
                this.startMouse = { x: event.clientX, y: event.clientY };
                this.startPos = { x: this.position.x, y: this.position.y };
                document.addEventListener('mousemove', this.handleResizing);
                document.addEventListener('mouseup', this.stopResizing);
            },
            handleResizing(event) {
                if (!this.isResizing) return;
                const dx = event.clientX - this.startMouse.x;
                const dy = event.clientY - this.startMouse.y;

                if (this.resizeDirection.includes('e')) {
                    this.size.width = Math.max(this.minWidth, this.startSize.width + dx);
                }
                if (this.resizeDirection.includes('w')) {
                    this.size.width = Math.max(this.minWidth, this.startSize.width - dx);
                    this.position.x = this.startPos.x + dx;
                }
                if (this.resizeDirection.includes('s')) {
                    this.size.height = Math.max(this.minHeight, this.startSize.height + dy);
                }
                if (this.resizeDirection.includes('n')) {
                    this.size.height = Math.max(this.minHeight, this.startSize.height - dy);
                    this.position.y = this.startPos.y + dy;
                }
            },
            stopResizing() {
                this.isResizing = false;
                this.resizeDirection = '';
                document.removeEventListener('mousemove', this.handleResizing);
                document.removeEventListener('mouseup', this.stopResizing);
            },
            save() {
                common.saveGlobalSetting('keypad', { x: this.position.x, y: this.position.y });
            },

            pressKey(key) {
                console.log(`keypress:${JSON.stringify(key)}`);
                this.$emit('keypress', key.number);
            },
        },
    };
</script>

<style scoped>
    .floating-window {
        position: absolute;
        background: white;
        border: 1px solid #ccc;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        user-select: none;
        pointer-events: auto;
        z-index: 999;
        display: flex;
        flex-direction: column;
    }

    .window-header {
        background: #f0f0f0;
        padding: 5px;
        cursor: move;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .window-content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    .pre-content{
        flex-grow: 1;
    }

    .resize-handle {
        position: absolute;
        width: 10px;
        height: 10px;
        background: #ccc;
    }

        .resize-handle:hover {
            background: #999;
        }

    .se {
        bottom: -5px;
        right: -5px;
        cursor: se-resize;
    }

    .sw {
        bottom: -5px;
        left: -5px;
        cursor: sw-resize;
    }

    .ne {
        top: -5px;
        right: -5px;
        cursor: ne-resize;
    }

    .nw {
        top: -5px;
        left: -5px;
        cursor: nw-resize;
    }

    .keypad-container {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f5f5f5;
    }

    .keypad {
        width: 300px;
        /*height: 240px;*/
        max-width: 90vw;
        max-height: 90vh;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .keypad-grid {
        flex: 3;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
    }

    .keypad-button {
        aspect-ratio: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        background-color: #fafafa;
        transition: background-color 0.2s;
    }

        .keypad-button:hover {
            background-color: #e0e0e0;
        }

        .keypad-button .q-icon {
            margin-bottom: 4px;
        }

        .keypad-button span {
            font-weight: 500;
            color: #333;
        }

    @media (max-width: 600px) {
        .keypad {
            width: 90vw;
            height: 60vh;
            padding: 12px;
        }

        .keypad-button .q-icon {
        }

        .keypad-button span {
        }
    }
</style>
